import React from "react";
import styles from "./styles.module.css";
import logo from "../../assets/img/logo-inter.png";
import emailjs from "emailjs-com";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  Box,
  Icon,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import {
  BiBuildings,
  BiBriefcaseAlt2,
  BiUser,
  BiMailSend,
  BiWorld,
  BiPhone,
  BiMessageRounded,
} from "react-icons/bi";

function mascara({ target }) {
  if (target.value.length === 0) target.value = "(" + target.value;
  if (target.value.length === 3) target.value = target.value + ") ";
}

const LandingPage = () => {
  const [errorPreferencia, setErrorPreferencia] = React.useState(false);
  const [checked, setChecked] = React.useState({
    "E-mail": false,
    Ligação: false,
    Whatsapp: false,
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onBlur",
  });

  const handleToggle = ({ target }) => {
    setChecked((s) => ({ ...s, [target.name]: !s[target.name] }));
  };

  const onSubmit = async (values) => {
    let preferenciaArray = [];
    Object.entries(checked).map((el) => {
      if (el[1] === true) {
        preferenciaArray.push(el[0]);
      }
      return preferenciaArray;
    });

    if (preferenciaArray.length < 1) {
      setErrorPreferencia(true);
      return;
    } else {
      setErrorPreferencia(false);
    }

    try {
      const templateParams = {
        nomeEmpresa: values.nomeEmpresa,
        tipoCliente: values.tipoCliente,
        nome: values.nomeContato,
        email: values.email,
        estado: values.estado,
        telefone: values.telefone,
        preferencia: preferenciaArray.toString(),
      };

      await emailjs
        .send(
          process.env.REACT_APP_SERVICE_ID,
          process.env.REACT_APP_TEMPLATE_ID,
          templateParams,
          process.env.REACT_APP_USER_ID,
        )
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Indicação enviada com sucesso",
            showConfirmButton: false,
            timer: 3000,
          });
        });

      reset();
    } catch (e) {
      console.log(e);
      Swal.fire({
        icon: "warning",
        title:
          "Algo deu errado! Entre em contato com o administrador do sistema",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
  };

  return (
    <main className={styles.landing}>
      <p className={styles.descricao}>
        Quando o assunto é <span>gestão de saúde</span>, seja sua, da sua
        empresa ou da sua entidade representativa, a{" "}
        <span>Interbrasil Saúde</span> é a escolha certa a se fazer.
      </p>
      <Box
        borderRadius="15px"
        backgroundColor="#f4f4f7"
        padding="24px"
        width="100%"
        maxWidth="600px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        boxShadow="0 15px 35px rgba(50,50,93,.1),0 5px 15px rgba(0,0,0,.07)"
      >
        <Box width="100%">
          <h4>Indique sua Empresa ou Entidade</h4>
          <p>Preencha corretamente os campos abaixo</p>
        </Box>
        <Box width="100%" marginTop="15px">
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
            <Box display="flex" flexDirection="column" gridRowGap="15px">
              <FormControl
                isInvalid={!!errors?.nomeEmpresa?.message}
                errortext={errors?.nomeEmpresa?.message}
                isRequired
              >
                <FormLabel htmlFor="nomeEmpresa">
                  Nome da empresa/entidade
                </FormLabel>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<Icon as={BiBuildings} color="gray.300" />}
                  />
                  <Input
                    placeholder="Nome da empresa/entidade"
                    backgroundColor="white"
                    id="nomeEmpresa"
                    type="text"
                    {...register("nomeEmpresa")}
                  />
                </InputGroup>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.tipoCliente?.message}
                errortext={errors?.tipoCliente?.message}
                isRequired
              >
                <FormLabel htmlFor="tipoCliente">Tipo de cliente</FormLabel>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<Icon as={BiBriefcaseAlt2} color="gray.300" />}
                  />
                  <Select
                    backgroundColor="white"
                    placeholder="Selecione o tipo"
                    id="tipoCliente"
                    type="text"
                    {...register("tipoCliente")}
                  >
                    <option value="Empresa">Empresa</option>
                    <option value="Entidade">Entidade</option>
                  </Select>
                </InputGroup>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.nomeContato?.message}
                errortext={errors?.nomeContato?.message}
                isRequired
              >
                <FormLabel htmlFor="nomeContato">Nome do contato</FormLabel>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<Icon as={BiUser} color="gray.300" />}
                  />
                  <Input
                    placeholder="Nome do contato"
                    backgroundColor="white"
                    id="nomeContato"
                    type="text"
                    {...register("nomeContato")}
                  />
                </InputGroup>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.email?.message}
                errortext={errors?.email?.message}
                isRequired
              >
                <FormLabel htmlFor="email">E-mail</FormLabel>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<Icon as={BiMailSend} color="gray.300" />}
                  />
                  <Input
                    placeholder="E-mail"
                    backgroundColor="white"
                    id="email"
                    type="email"
                    {...register("email")}
                  />
                </InputGroup>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.estado?.message}
                errortext={errors?.estado?.message}
                isRequired
              >
                <FormLabel htmlFor="estado">Estado</FormLabel>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<Icon as={BiWorld} color="gray.300" />}
                  />
                  <Select
                    backgroundColor="white"
                    placeholder="Selecione o estado"
                    id="estado"
                    type="text"
                    {...register("estado")}
                  >
                    <option value="Não selecionado">Nenhum</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                    <option value="EX">Estrangeiro</option>
                  </Select>
                </InputGroup>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.telefone?.message}
                errortext={errors?.telefone?.message}
                isRequired
              >
                <FormLabel htmlFor="telefone">Telefone</FormLabel>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<Icon as={BiPhone} color="gray.300" />}
                  />
                  <Input
                    maxLength="15"
                    mask="(00) 000000000"
                    onKeyPress={mascara}
                    placeholder="Telefone"
                    backgroundColor="white"
                    id="telefone"
                    type="text"
                    {...register("telefone")}
                  />
                </InputGroup>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.contato?.message}
                errortext={errors?.contato?.message}
                isRequired
              >
                <FormLabel htmlFor="telefone">Preferência de contato</FormLabel>
                <InputGroup>
                  <Box
                    display="flex"
                    alignItems="center"
                    backgroundColor="white"
                    width="100%"
                    borderRadius="7px"
                    border="solid 1px #E2E8F0"
                    height="40px"
                  >
                    <Icon
                      as={BiMessageRounded}
                      color="gray.300"
                      margin="0 15px 0 10px"
                    />
                    {Object.keys(checked).map((key, i) => (
                      <label
                        style={{ cursor: "pointer" }}
                        className={styles.preferenciaLabel}
                        key={i}
                      >
                        <input
                          style={{
                            cursor: "pointer",
                            width: "17px",
                            height: "17px",
                          }}
                          type="checkbox"
                          onChange={handleToggle}
                          name={key}
                          checked={checked[key]}
                        />
                        {key}
                      </label>
                    ))}
                  </Box>
                </InputGroup>
                {errorPreferencia && (
                  <span
                    className={styles.errorMessage}
                    style={{ marginTop: "2px" }}
                  >
                    Por favor, selecione uma ou mais preferência de contato
                  </span>
                )}
              </FormControl>

              <Button isLoading={isSubmitting} type="submit" colorScheme="blue">
                Indicar
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
      <Box maxWidth="600px" width="100%" justifyContent="center" display="flex">
        <img src={logo} alt="InterBrasil Saúde" />
      </Box>
    </main>
  );
};

export default LandingPage;
